import {
  Workflow,
  Activity,
  AppWindow,
  Bell,
  Boxes,
  Building2,
  BrainCircuit,
  CalendarDays,
  LayoutDashboard,
  ListChecks,
  MessageSquareText,
  Settings2,
  Siren,
  UsersRound,
} from '@lucide/vue'
import type { Component } from 'vue'
import type { SpotlightIcon } from '~~/shared/spotlight/providerCatalog'

export const spotlightIconComponents = {
  workflow: Workflow,
  app: AppWindow,
  dashboard: LayoutDashboard,
  message: MessageSquareText,
  incident: Siren,
  monitoring: Activity,
  notification: Bell,
  inventory: Boxes,
  todo: ListChecks,
  calendar: CalendarDays,
  skills: BrainCircuit,
  users: UsersRound,
  settings: Settings2,
  platform: Building2,
} satisfies Record<SpotlightIcon, Component>
